import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { SwiperComponent, SwiperModule } from 'swiper/angular';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { InputDirective } from './directives/input/input.directive';
import { GetFlexSectionPipe } from './pipes/get-flex-section.pipe';

import { CountDownComponent } from './components/countDown/count-down.component';
import { LoadingComponent } from './components/loading/loading.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { AutocompleteDirective } from './directives/autocomplete.directive';
import { DatepickerDirective } from './directives/datepicker.directive';
import { DumpingModalComponent } from './components/dumping-modal/dumping-modal.component';
import { RouterLink } from '@angular/router';
import { BypassHtmlSanitizerPipe } from './pipes/bypassHtmlSanitizer.pipe';
import { IhoSwiperComponent } from './components/swiper/swiper.component';
import { LastReserveCardComponent } from './components/last-reserve-card/last-reserve-card.component';
import { RialToTomanPipe } from './pipes/rial-to-toman.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { GetEcolodgeDateInfoPipe } from './pipes/get-ecolodge-date-info.pipe';
import { CardCityComponent } from './components/card-city/card-city.component';
import { HotelCardSkeletonComponent } from '../pages/home/skeletons/hotel-card-skeleton/hotel-card-skeleton.component';
import { CustomMasonryComponent } from './components/custom-masonry/custom-masonry.component';
import { MasonryItemComponent } from './components/custom-masonry/item/item.component';
import { WhiteBoxBorderBottomComponent } from './components/white-box-border-bottom/white-box-border-bottom.component';
import { WhiteBoxBorderBottomItemComponent } from './components/white-box-border-bottom/item/item.component';
import { IsoToJalaliPipe } from './pipes/iso-to-jalali.pipe';
const MATERIAL_MODULES = [
    MatSlideToggleModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatRippleModule,
    MatBottomSheetModule,
    DatepickerComponent,
];

@NgModule({
    declarations: [
        InputDirective,
        GetFlexSectionPipe,
        DumpingModalComponent,
        BypassHtmlSanitizerPipe,
        CustomMasonryComponent,
        MasonryItemComponent,
        WhiteBoxBorderBottomComponent,
        WhiteBoxBorderBottomItemComponent,
        IsoToJalaliPipe,
        HotelCardSkeletonComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        ...MATERIAL_MODULES,
        SkeletonComponent,
        AutoCompleteComponent,
        AutocompleteDirective,
        DatepickerDirective,
        SwiperModule,
        LoadingComponent,
        LastReserveCardComponent,
        CountDownComponent,
        NgOptimizedImage,
        RouterLink,
        IhoSwiperComponent,
        RialToTomanPipe,
        FilterPipe,
        GetEcolodgeDateInfoPipe,
        CardCityComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        AutoCompleteComponent,
        DatepickerComponent,
        ...MATERIAL_MODULES,
        InputDirective,
        GetFlexSectionPipe,
        BypassHtmlSanitizerPipe,
        IsoToJalaliPipe,
        SwiperModule,
        AutoCompleteComponent,
        AutocompleteDirective,
        SkeletonComponent,
        DatepickerDirective,
        SkeletonComponent,
        LoadingComponent,
        LastReserveCardComponent,
        CountDownComponent,
        NgOptimizedImage,
        SwiperComponent,
        IhoSwiperComponent,
        RialToTomanPipe,
        FilterPipe,
        GetEcolodgeDateInfoPipe,
        CustomMasonryComponent,
        MasonryItemComponent,
        WhiteBoxBorderBottomComponent,
        WhiteBoxBorderBottomItemComponent,
        HotelCardSkeletonComponent,
        CardCityComponent
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline', floatLabel: 'auto' },
        },
    ],
})
export class SharedModule { }
